import { BehaviorType, } from "../types";
import Behavior from "../types/Behavior";
import QuestionVisibilityTracker from "../utils/QuestionVisibilityTracker";
class QuestionShownBehavior extends Behavior {
    constructor(plasm, appName, trackingOptions, addMetadata) {
        super(plasm, appName, addMetadata);
        this.tracker = null;
        this.id = BehaviorType.question_shown;
        this.trackingOptions = trackingOptions;
        this.handler = () => { };
    }
    start() {
        this.tracker = new QuestionVisibilityTracker({
            source: this.trackingOptions,
            onShown: (questionId, details) => this.onQuestionShown(questionId, details),
        });
        this.tracker.start();
        this.plasm.debug(`Behavior ${this.id} started`);
    }
    stop() {
        if (this.tracker != null) {
            this.tracker.stop();
            this.tracker = null;
        }
        this.plasm.debug(`Behavior ${this.id} stopped`);
    }
    attachToDocument(doc) {
        var _a;
        (_a = this.tracker) === null || _a === void 0 ? void 0 : _a.attachToDocument(doc);
    }
    detachFromDocument(doc) {
        var _a;
        (_a = this.tracker) === null || _a === void 0 ? void 0 : _a.detachFromDocument(doc);
    }
    onQuestionShown(questionId, details) {
        this.addLog(new Event(this.id), this.id, { questionId }, details.clientTime);
    }
}
export default QuestionShownBehavior;
